/* eslint-disable no-sequences */
import React from "react";
import Return from "../../../images/return.png";
import LogoNovidades from "../../../images/logo-novidades.png";
import { BaSeButton, BaSeIcon } from "@base/react";
import { AddNovidadesModel } from "./addNovidades.model";
import { mapValueMsg } from "./mapValuesPage";
import { formatDefaultValueSelect } from "../../../utils/mask";
// import { formatDateToBRWithHour } from '../../../utils/time';
import { formatDateToBR } from "../../../utils/time";
import styles from "./styles.module.scss";

export const DEFAULT_VALUE_SELECIONE = "Selecione";
export const DEFAULT_VALUE_ALL = "Todos";

export const AddNovidades = (props) => {
  const { onClose, selectedRow, allValuesOptions, typeScreen } = props;

  const {
    novidade,
    isLoadingCidades,
    cidades,
    updateValue,
    recoveredByid,
    adicionarNotificacao,
    onChangeUF,
    updatePics,
  } = AddNovidadesModel({ selectedRow, typeScreen, onClose });

  const backList = () => {
    onClose();
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: "#6699ff" }}
        >
          <div className={styles.modal_flex_direction_row}>
            <img alt="imagem" className="logo-novidade" src={LogoNovidades} />
            <h2 className={styles.text_color_branco_titulo}>Novidades</h2>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>
        {/* <hr size="1" className="separador-servicos"></hr> */}
        <div>
          <div className={styles.div_tabelas_novidades_filtro}>
            <div className={styles.separator_novidades}>
              <h3>{mapValueMsg[typeScreen]}</h3>
            </div>

            <div className={styles.big_container1_addNews}>
              <div className={styles.left_container_addNews}>
                {/* LINHA 1 */}
                <div>
                  <div>
                    <label htmlFor="input-nome">Título</label>
                    <span className={styles.mandatory_novidades}>*</span>
                  </div>

                  <input
                    value={novidade?.titulo ?? ""}
                    id="input-nome"
                    onChange={(evento) => {
                      const newValue = evento.target.value;
                      if (newValue.length < 141)
                        updateValue("titulo", evento.target.value);
                    }}
                    placeholder="Digite aqui o título"
                  />
                  <div className={styles.sublabel_wrapper}>
                    <p className={styles.sublabel}>
                      {novidade?.titulo?.length ?? 0}/140
                    </p>
                  </div>
                </div>

                {/* LINHA 2 */}
                <div>
                  <div>
                    <label htmlFor="input-descricao">Descrição</label>
                    <span className={styles.mandatory_novidades}>*</span>
                  </div>
                  <textarea
                    rows="7"
                    value={novidade?.descricao ?? ""}
                    style={{ paddingTop: "1.5rem" }}
                    id="input-descricao"
                    onChange={(evento) => {
                      const newValue = evento.target.value;
                      if (newValue.length < 501)
                        updateValue("descricao", evento.target.value);
                    }}
                    placeholder="Digite aqui a descrição da funcionalidade"
                  />
                  <div className={styles.sublabel_wrapper}>
                    <p className={styles.sublabel}>
                      {novidade?.descricao?.length ?? 0}/500
                    </p>
                  </div>
                </div>

                {/* LINHA 3 */}
                <div className={styles.versao_row_content}>
                  {/* VERSÃO */}
                  <div>
                    <div>
                      <label htmlFor="input-versao">Versão do App</label>
                    </div>
                    <select
                      id="input-versao"
                      value={novidade?.versao?.id ?? ""}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.versoes,
                          event.target.value,
                          false
                        );
                        updateValue("versao", recovered);
                      }}
                    >
                      <option value={""}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.versoes.map((versao) => (
                        <option value={versao.id} title={versao.android}>
                          {formatDefaultValueSelect(versao.android)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* MENU */}
                  <div>
                    <div>
                      <label htmlFor="input-menu">Menu relacionado</label>
                      <span className={styles.mandatory_novidades}>*</span>
                    </div>
                    <select
                      id="input-menu"
                      value={novidade?.menu?.id ?? ""}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.menus,
                          event.target.value,
                          true
                        );
                        updateValue("menu", recovered[0]);
                      }}
                    >
                      <option value={""}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.menus.map((menu) => (
                        <option value={menu.id} title={menu.nome}>
                          {formatDefaultValueSelect(menu.nome)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* TIPO USER */}
                  <div>
                    <div>
                      <label htmlFor="input-tipoUser">Tipo de usuário</label>
                    </div>
                    <select
                      id="input-tipoUser"
                      value={novidade?.perfilUsuario?.id ?? ""}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.perfis,
                          event.target.value,
                          false
                        );
                        updateValue("perfilUsuario", recovered);
                      }}
                    >
                      <option value={""}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.perfis.map((perfil) => (
                        <option value={perfil.id} title={perfil.nome}>
                          {formatDefaultValueSelect(perfil.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className={styles.right_container_addNews}>
                {/* LINHA 1 */}
                <div>
                  <div>
                    <label htmlFor="image-input">Imagem</label>
                    <span className={styles.mandatory_novidades}>*</span>
                  </div>
                  <div className={styles.input_row}>
                    <input
                      id="image-input"
                      style={{ display: "none" }}
                      accept="image/*"
                      type="file"
                      onChange={(event) => updatePics("imagem", event)}
                    />
                    <div className={styles.image_container}>
                      {novidade?.imagem?.base64 ? (
                        <img
                          src={`data:image/png;base64, ${novidade?.imagem?.base64}`}
                          alt=""
                        />
                      ) : (
                        novidade?.imagem?.urlConteudo && (
                          <img src={novidade?.imagem?.urlConteudo} alt="" />
                        )
                      )}
                    </div>
                    <label
                      for="image-input"
                      className={styles.image_upload_icon}
                      id="label-icon"
                    >
                      <BaSeIcon
                        size={22}
                        name="image-upload"
                        color="#6699ff"
                        description="teste"
                      />
                    </label>
                  </div>
                </div>

                {/* LINHA 2 */}
                <div>
                  <div>
                    <label htmlFor="input-typeNews">Tipo da Novidade</label>
                    <span className={styles.mandatory_novidades}>*</span>
                  </div>
                  <select
                    value={novidade?.tipo ?? ""}
                    id="input-typeNews"
                    onChange={(event) => {
                      updateValue("tipo", event.target.value);
                    }}
                  >
                    <option value={""}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.tipos.map((tipo) => (
                      <option value={tipo} title={tipo}>
                        {formatDefaultValueSelect(tipo)}
                      </option>
                    ))}
                  </select>
                </div>

                {/* LINHA 3 */}
                <div className={styles.url_row}>
                  {(novidade?.tipo === "VIDEO" ||
                    novidade?.tipo === "DOCUMENTO") && (
                    <div>
                      <div>
                        <label htmlFor="input-url">URL</label>
                        <span className={styles.mandatory_novidades}>*</span>
                      </div>
                      <input
                        value={novidade?.urlConteudo ?? ""}
                        id="input-url"
                        onChange={(evento) => {
                          updateValue("urlConteudo", evento.target.value);
                        }}
                        placeholder="Digite aqui a URL"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* <div className={styles.div_acoes_novidades}>
              

                
              </div>
            </div> */}

            <div className={styles.separator_novidades}>
              <h3>Abrangência da Novidade</h3>
            </div>

            <div className={styles.div_acoes_novidades}>
              <div className={styles.container_itens}>
                <div
                  style={{ height: 100, display: "flex", marginTop: "1rem" }}
                >
                  <div>
                    <p className="text-campos-cadastro">UF</p>
                    <select
                      value={novidade?.uf?.id ?? ""}
                      className="btn-select-funcionalidades"
                      onChange={(event) =>
                        onChangeUF(allValuesOptions.ufs, event.target.value)
                      }
                    >
                      <option value={""}>Todas</option>
                      {allValuesOptions.ufs.map((uf) => (
                        <option value={uf.id} title={uf.nome}>
                          {uf.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1, maxWidth: 500, marginLeft: "1rem" }}>
                    <p className="text-campos-cadastro">Cidade</p>
                    <select
                      disabled={isLoadingCidades}
                      value={novidade?.cidade?.id ?? ""}
                      className="btn-select-funcionalidades"
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          cidades,
                          event.target.value,
                          false
                        );
                        updateValue("cidade", recovered);
                      }}
                    >
                      {isLoadingCidades ? (
                        <option value={""}>Carregando cidades</option>
                      ) : (
                        <>
                          <option value={""}>Todas</option>
                          {cidades.map((cidade) => (
                            <option value={cidade.id} title={cidade.nome}>
                              {cidade.nome}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div
                className={styles.flex_button}
                style={{ alignSelf: "flex-end" }}
              >
                <BaSeButton
                  color="#6699ff"
                  value={
                    typeScreen !== 3 ? "Incluir Novidade" : "Editar Novidade"
                  }
                  onClick={adicionarNotificacao}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.updatedAt_novidades_container}>
          {novidade.atualizadoPor && typeScreen === 3 && (
            <h5>
              Atualizado em {formatDateToBR(novidade.ultimaAtualizacao)} por{" "}
              {novidade?.atualizadoPor?.nome}
            </h5>
          )}
          {novidade.criadoPor && typeScreen === 3 && (
            <h5>
              Criado em {formatDateToBR(novidade.dataCriacao)} por{" "}
              {novidade?.criadoPor?.nome}
            </h5>
          )}
        </div>
      </div>
    </div>
  );
};
